import {
  ArrayInput,
  NumberInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useTranslate,
} from 'react-admin';
import { Box, Stack, Typography, Button as MUIButton, Tooltip, IconButton } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { chains, typeRpc, typeService } from 'src/assets/data';

interface FormProps {}
const CreateForm = (props: FormProps) => {
  const t = useTranslate();

  const { setValue } = useFormContext();
  const chainId = useWatch({ name: 'chainId' });
  const name = useWatch({ name: 'name' });
  useEffect(() => {
    const chain = chains.find((c) => c.id === chainId);
    if (chain) {
      setValue('name', chain.name);
    }
  }, [chainId, setValue]);

  return (
    <>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '20%', flexShrink: 0 }}>
          {t('module.systemRpc.chain')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <SelectInput
            label={false}
            source="chainId"
            validate={[required()]}
            fullWidth
            helperText={<span style={{ color: 'red' }}></span>}
            choices={chains}
          />
          <TextInput source="name" sx={{ display: 'none' }} />
          <TextInput source="value" defaultValue={null} sx={{ display: 'none' }} />
        </Box>
      </Stack>
      <Stack direction={'column'} alignItems={'stretch'} spacing={2} mb={1}>
        <Typography variant="body2">URI - Weight</Typography>

        <Box
          sx={{
            maxHeight: 400,
            overflowY: 'auto',
            pt: 3,
            pb: 3,
          }}
        >
          <ArrayInput source="value" label="">
            <SimpleFormIterator
              inline
              sx={{
                '.RaSimpleFormIterator-line': {
                  mb: 2,
                  gap: 2,
                  pb: 2,
                },
                '.RaSimpleFormIterator-form': {
                  '@media (min-width: 1200px)': {
                    width: '90%',
                  },
                },
              }}
            >
              <Stack direction={'column'} sx={{ width: '100%' }}>
                <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
                  <SelectInput
                    source="service"
                    validate={[required()]}
                    helperText={false}
                    choices={typeService}
                    sx={{
                      marginTop: 0,
                    }}
                  />
                  <TextInput
                    source="uri"
                    helperText={false}
                    fullWidth
                    validate={[required()]}
                    sx={{
                      flexGrow: 1,
                    }}
                  />
                  <SelectInput
                    source="type"
                    validate={[required()]}
                    helperText={false}
                    choices={typeRpc}
                    sx={{
                      marginTop: 0,
                    }}
                  />
                  <NumberInput
                    source="weight"
                    helperText={false}
                    validate={[required()]}
                    sx={{
                      flexGrow: 0,
                    }}
                  />
                </Stack>
                {/* <Stack >
                                    <CustomTagInput source="tag" label={t("module.categories.tags")} />
                                </Stack> */}
              </Stack>
            </SimpleFormIterator>
          </ArrayInput>
        </Box>
      </Stack>
    </>
  );
};

export default CreateForm;
